import { render, staticRenderFns } from "./NextGameWidget.vue?vue&type=template&id=6694c412&scoped=true"
import script from "./NextGameWidget.vue?vue&type=script&lang=js"
export * from "./NextGameWidget.vue?vue&type=script&lang=js"
import "./NextGameWidget.vue?vue&type=style&index=0&id=6694c412&prod&scoped=true&lang=css"
/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6694c412",
  null
  
)

export default component.exports